export interface PollingController {
  start: () => void;
  stop: () => void;
  isRunning: () => boolean;
}

export interface CreatePollingParams {
  intervalMs: number;
  task: () => Promise<void>;
  onError?: (error: unknown) => void;
}

export function createPolling(params: CreatePollingParams): PollingController {
  let timerId: number | null = null;
  let running = false;
  let inFlight = false;

  const tick = async (): Promise<void> => {
    if (!running || inFlight) {
      return;
    }

    inFlight = true;

    try {
      await params.task();
    } catch (error) {
      params.onError?.(error);
    } finally {
      inFlight = false;
    }
  };

  return {
    start() {
      if (running) {
        return;
      }

      running = true;
      void tick();

      timerId = window.setInterval(() => {
        void tick();
      }, params.intervalMs);
    },

    stop() {
      running = false;

      if (timerId !== null) {
        window.clearInterval(timerId);
        timerId = null;
      }
    },

    isRunning() {
      return running;
    }
  };
}